import { Action } from 'redux'

import ReferenceInterface from '../../interfaces/client/Reference'

import { ADD_PASSENGER_REFERENCES } from '../../actions/bookings/addPassengersReferences'
import { RESET_BOOKING } from '../../actions/bookings/resetBooking'

export interface PassengersBookedState {
  byId: {
    [id: string]: string
  }
  allIds: string[]
}

export interface PassengersBookedAction extends Action {
  references: ReferenceInterface
}

export const initialState: PassengersBookedState = {
  byId: {},
  allIds: [],
}

export default (
  state = initialState,
  action: PassengersBookedAction = {
    type: '',
    references: {},
  }
) => {
  switch (action.type) {
    case ADD_PASSENGER_REFERENCES:
      return {
        ...state,
        byId: {
          ...state.byId,
          ...action.references,
        },
        allIds: [...state.allIds, ...Object.keys(action.references)],
      }

    case RESET_BOOKING:
    case '@@router/LOCATION_CHANGE':
      return initialState

    default:
      return state
  }
}
